import { createRoot } from "react-dom/client";
import Lenis from "@studio-freight/lenis";
import { Suspense, useEffect } from "react";
import { useStore } from "./store/store";
import i18next from "i18next";
import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import CustomEase from "gsap/dist/CustomEase";

import { Canvas } from "@react-three/fiber";
import Bowser from "bowser";
import { Leva } from "leva";

import * as THREE from "three";

import Loader from "./components/Loader/Loader";
import WebGL from "./components/WebGL/WebGL";
import Icons from "./components/Icons/Icons";
import Logo from "./components/Logo/Logo";
import Dropzone from "./components/Dropzone/Dropzone";
import Reinvented from "./components/Reinvented/Reinvented";
import Discover from "./components/Discover/Discover";
import ColorsAndFabric from "./components/ColorsAndFabric/ColorsAndFabric";
import Biography from "./components/Biography/Biography";
import Scenography from "./components/Scenography/Scenography";
import SavoirFaire from "./components/SavoirFaire/SavoirFaire";
import Footer from "./components/Footer/Footer";
import Collection from "./components/Collection/Collection";
import ToggleSound from "./components/ToggleSound/ToggleSound";

import "./i18n";
import "./styles/global.scss";
import Terms from "./components/Terms/Terms";
import Header from "./components/Header/Header";
import ElleMurmura from "./components/ElleMurmura/ElleMurmura";

const container = document.getElementById("root");
const root = createRoot(container);

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);

function App() {
  const setLenis = useStore((state) => state.setLenis);
  const loadingScreen = useStore((state) => state.loadingScreen);
  const hasInteracted = useStore((state) => state.hasInteracted);
  const setBowser = useStore((state) => state.setBowser);
  const [platform, setPlatform] = useStore((state) => [
    state.platform,
    state.setPlatform,
  ]);

  useEffect(() => {
    // console.log(window.location);

    const queryParameters = new URLSearchParams(window.location.search);
    const lang = queryParameters.get("lang");

    // console.log(lang);
    if (lang === "it") {
      //   console.log("change language it");
      //   // i18next.changeLanguage("it");
      document.body.classList.add("it");
    } else {
      //   console.log("change language en");
      document.body.classList.remove("it");
      //   // i18next.changeLanguage("en");
    }

    const browser = Bowser.getParser(window.navigator.userAgent);

    setBowser(browser);
    setPlatform(browser.getPlatformType(true));

    // init lenis
    window.scrollTo(0, 0);
    const lenis = new Lenis({
      smoothTouch: browser.getPlatformType("tablet") ? true : false,
      touchMultiplier: browser.getPlatformType("tablet") ? 3 : 2,
    });
    window.lenis = lenis;
    setLenis(lenis);

    const update = (time, delta) => {
      lenis.raf(time);
    };

    lenis.on("scroll", ScrollTrigger.update);

    //  if (enableProxy) {
    // ScrollTrigger.scrollerProxy(document.documentElement, {
    //   scrollTop(value) {
    //     return lenis.scroll;
    //   },
    //   getBoundingClientRect() {
    //     return {
    //       top: 0,
    //       left: 0,
    //       width: window.innerWidth,
    //       height: window.innerHeight,
    //     };
    //   },
    // });
    //  }

    gsap.ticker.add(update);

    if (
      browser.getPlatformType() === "tablet" ||
      browser.getPlatformType() === "mobile"
    ) {
      ScrollTrigger.normalizeScroll(true);
    }

    if (process.env.NODE_ENV !== "development" && loadingScreen) {
      lenis.stop();
    }

    if (process.env.NODE_ENV === "development") {
      document.body.style.overflowY = "visible";
    }

    // const userLang = navigator.language || navigator.userLanguage;

    // switch (userLang) {
    //   case "it-IT":
    //     if (lang === `it`) {
    //       //lang already = it, do nothing
    //       return;
    //     } else if (lang === null) {
    //       //lang is not set
    //       window.location.pathname = `/exhibition/?lang=it`;
    //       return;
    //     } else {
    //       window.location.pathname = `/exhibition/?lang=it`;
    //     }

    //     break;

    //   default:

    //     break;
    // }

    // let portrait = window.matchMedia("(orientation: portrait)");

    // portrait.addEventListener("change", function (e) {
    //   if (e.matches) {
    //     // Portrait mode
    //     ScrollTrigger.refresh();
    //     console.log("portrait");
    //   } else {
    //     // Landscape
    //     console.log("landscape");
    //     ScrollTrigger.refresh();
    //   }
    // });

    return () => {
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div>
      {process.env.NODE_ENV !== "development" && loadingScreen ? (
        <Loader />
      ) : null}

      {platform === "desktop" && !hasInteracted ? <ToggleSound /> : null}

      <Header />
      <Reinvented />
      <ElleMurmura />
      <Discover />
      <ColorsAndFabric />
      <Collection />
      <Biography />
      <Scenography />
      <SavoirFaire />

      {/* <Dropzone /> */}

      <Footer />

      <Terms />

      <Leva
        hidden
        // collapsed
      />

      <div id="canvas-container">
        <Suspense>
          <Canvas
            gl={{
              toneMapping: THREE.NoToneMapping,
            }}
          >
            <WebGL />
          </Canvas>
        </Suspense>
      </div>
    </div>
  );
}

root.render(<App />);
